import { createFileRoute } from "@tanstack/react-router"

import PerformanceTab from "~/components/demand-2/tabs/PerformanceTab"

export const Route = createFileRoute("/_auth/demand/noos/$collectionId/_layout/performance")({
  component: RouteComponent,
})

function RouteComponent() {
  return <PerformanceTab kind="noos" />
}
